

export function assignPayloadByDict(payload: any, dict: { [K: string]: any; } | undefined) {
    if (dict === undefined)
        return
    for (const key in dict) {
        const arg = dict[key]
        let key_words = key.split('_')
        for (let i = 0; i < key_words.length; i++) {
            key_words[i] = key_words[i][0].toUpperCase() + key_words[i].slice(1)
        }
        const setter = 'set'.concat(...key_words)
        // console.log(payload, setter)
        // @ts-ignore: TS7053
        payload[setter](arg)
    }
}